<div class="error">
    <img src="assets/images/not-found-page.svg" alt="" class="error__img">
    <div class="error__label">
        <span>{{ 'error.page.404.title' | translate }}</span>
    </div>
    <div class="error__desc">
        <span>{{ 'error.page.404.description' | translate }}</span>
    </div>
    <button class="error__btn">
        <a href="https://www.telkomsel.com">{{ 'error.page.404.button' | translate }}</a>
    </button>
</div>